































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { prompt, operationTransfer, moneyFormat } from "@root/lib/utils";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore
} from "@root/lib/decorator";
import { required } from "@root/lib/rules.js";

import GtTable from "./components/gt-table/table.vue";
import GtTableColumn from "./components/gt-table/column.vue";
import paymentType from "./components/paymentType/index.vue";
import tableHead from "./custom/tableHead.vue";
import debounce from "lodash.debounce";

import RemoteSelect from "@/components/custom/RemoteSelect.vue";

import { sleep } from "@root/lib/utils";

import NP from "number-precision";

const Order = namespace("wtOrder");
const Root = namespace("root");
const common = namespace("common");
const DEFAULT_DELIVERY_PARAMS = {
  expressCode: "other",
  companyName: "other",
  companyCode: "other"
};
@Component({
  components: {
    GtTable,
    GtTableColumn,
    tableHead,
    paymentType,
    RemoteSelect
  }
})
@pagination("getData")
@SearchbarControl()
@loading()
@IsMore(false)
// @Root.State permission;
export default class wtOrder extends Vue {
  @Root.Action getCartCount;
  @Root.State ddCodes;
  // @Order.State orderList;
  // @Order.State orderDataList;
  @Order.State StatusCountList;

  @Order.Mutation easyMutate;

  @Order.Action queryOrderPages;
  @Order.Action queryWtOrderPage;
  @Order.Action cancelOrder;
  @Order.Action dealWithDelivery;
  @Order.Action queryWtOrderStatusCount;
  @Order.Action querWtDeclaration;
  @Order.Action getOrderDetail;
  @Order.Action dealWithDeliveryBatch; // 批量发货
  @Order.Action bulkdelivery; // 批量报单

  @Order.Action confirmPay;
  @Order.Action dealWithReceived;
  @Order.Action exportOrder;
  @Order.Action wtCreateReturn; // 31,42,取消订单
  @Order.Action findCompressedDeclarationStatus; // 查询保单状态数据字典
  @Order.Action getPCRAttr;
  @Order.Action queryBaseStorePage;

  @Root.Action getMemberStatus;
  @common.Action getDict;
  @common.State wtDicCodes;
  @common.Action getDataValue;

  private isK1Project = true; // 区别K1和GiTi
  private orderDataList = [];

  private form = {
    orderCode: "",
    serialNumber: "",
    k1Org: "",
    k2Org: "",
    payMentType: "",
    distributionType: "",
    orderTypeWt: "",
    date: "",
    declarationStatus: "",
    patternList: "",
    specificationsList: "",
    receiveName: "",
    verificationStatus: "",
    payMent: ""
  };
  private activeName: string = "";
  private orderCode: string = "";
  private isShipOrder: boolean = false;
  private dialogFormVisible: boolean = false;
  private isExportDialogVisible: boolean = false;
  private dialogRowInfo = {};
  private orderDeliveryDtlIns: any[] = [];
  private confirmPaymentPrice: string = "";
  private packageInfoData: any = null;
  private loading: boolean = false;
  private batchLoading: boolean = false; // 批量相关的loading
  // Cancel dialog
  private OTHER_CANCEN_REASON: string = "CR003";
  private currentExpressList: any[] = [];
  private cancelForm = {
    cancelCode: "CR001",
    cancelRemark: ""
  };
  // btn index
  private btnIdx = null;
  private selectedOrderDatas = [];

  // 报单状态列表
  declarationList: any = [];
  private patternDataOptions = [];
  private specificationDataOptions = [];
  private verificationStatusList = [];

  memberType: any = "";
  marketType: any = "";
  showFinanceInfo: any = false;

  // 是否显示全部商品， 默认最多展示3行，超出隐藏
  showAllProducts: any = false;
  getShowAllProductsFn() {
    let list: any = this.orderListComputed.filter(_ => !_.showRowAllProducts);
    console.log(list.length, "--showAllProducts");
    if (list.length > 0) {
      // 如果找到了不展开的订单行，则返回false
      this.showAllProducts = false;
    } else {
      // 如果没有找到不展开的订单行，则返回true
      this.showAllProducts = true;
    }
  }
  async triggerShowRowProducts(row) {
    row.showRowAllProducts = !row.showRowAllProducts;
    if (!row.showRowAllProducts) {
      this.showAllProducts = false;
    } else {
      this.getShowAllProductsFn();
    }
  }
  triggerPageProductsFn() {
    if (this.showAllProducts) {
      this.orderListComputed.forEach(_ => {
        _.showRowAllProducts = false;
      });
      this.showAllProducts = false;
    } else {
      this.orderListComputed.forEach(_ => {
        _.showRowAllProducts = true;
      });
      this.showAllProducts = true;
    }
  }

  get rules() {
    return {
      required: required("必填")
    };
  }

  //  切换 tab 必要
  handleClick(val) {
    this.activeName = val;
    (this as any).currentPage = 1;
    this.getData();
  }

  get orderListComputed() {
    const {
      ORDER_STATUS_MAP = {},
      ORDER_PAYMENT_TYPE_MAP = {},
      PAY_STATUS_MAP = {},
      ORDER_TYPE_MAP = {},
      WT_DISTRIBUTION_TYPE_MAP = {},
      PAYMENT_METHOD_MAP
    } = this.ddCodes;
    return (
      this.orderDataList &&
      this.orderDataList.map(orderItem => {
        this.$set(orderItem, "editLoading", false);
        let {
          salePrice,
          orderStatus: status,
          payMentType,
          payMent: payMethod,
          payStatus = "0",
          // orderType,
          // orderOperationType,
          // payChannel,
          distributionType,
          discount = 0,
          coupon = 0,
          orderProductOutList: products = [],
          orderReceiveOut,
          K1Name,
          K1Code,
          buyerRemark,
          serialNumber,
          payMentFee, // 支付手续费
          finalArrival, // 最终到账
          wtOrderStatusChange: {
            createTime,
            confirmDeliveryTime,
            finalShippedTime,
            cancleTime
          }
        } = orderItem;

        orderReceiveOut = orderReceiveOut || {};

        let totalCount = 0;
        products.forEach(item => {
          let { count } = item;
          totalCount = NP.plus(totalCount, count);
        });
        const pStr = "-";
        const formatData = {
          headInfoTips: [
            {
              label: "发货客户：",
              value: K1Name && K1Code ? `${K1Name}（${K1Code}）` : pStr
            },
            {
              label: "备注：",
              value: buyerRemark || pStr
            },
            {
              label: "流水编号：",
              value: serialNumber || pStr
            },
            {
              label: "支付手续费：",
              value: payMentFee || pStr
            },
            {
              label: "最终到账：",
              value: finalArrival || pStr
            },
            {
              label: "发货时间：",
              value: finalShippedTime || pStr
            },
            {
              label: "收货时间：",
              value: confirmDeliveryTime || pStr
            },

            {
              label: "订单取消时间：",
              value: cancleTime || pStr
            }
          ],
          createTime: createTime || pStr, // 下单时间
          statusString: this.$jp(ORDER_STATUS_MAP[status]),
          paymentTypeString: this.$jp(ORDER_PAYMENT_TYPE_MAP[payMentType]),
          payMethodString: this.$jp(PAYMENT_METHOD_MAP[payMethod]),
          payMethod,
          distributionTypeString: this.$jp(
            WT_DISTRIBUTION_TYPE_MAP[distributionType]
          ),
          payStatusString: this.$jp(PAY_STATUS_MAP[payStatus]),
          discount,
          coupon,
          products,
          totalCount,
          status,
          payMentFee, // 支付手续费
          finalArrival, // 最终到账
          ...orderReceiveOut,
          ...orderItem
        };
        // console.log(formatData, "formatrdata ");
        return formatData;
      })
    );
  }

  tableRowOperate(row) {
    const {
      orderStatus: status,
      payMentType,
      declarationStatus,
      afterSales
    } = row;
    const afterSaleMsg = payMentType === "online" ? "退款中" : "取消中";
    const operateMap = {
      0: {
        func: () => {},
        label: ""
      },
      1: {
        func: idx => this.handleOperate(row, "cancel", idx),
        label: "取消订单"
      },
      2: {
        func: idx => this.handleOperate(row, "shiporder", idx),
        label: "发货",
        hasBtn: !!afterSales
      },
      3: {
        func: idx => this.handleOperate(row, "shipDeclarationOrder", idx),
        label: "发货并报单",
        hasBtn: !!afterSales
      },
      4: {
        func: () => this.declarationHandle(row),
        label: "报单"
      },
      5: {
        func: null,
        label: "报单中"
      },
      6: {
        func: afterSales ? false : idx => this.handleRouteChange(row, idx),
        label: afterSales ? afterSaleMsg : "取消订单"
      },
      7: {
        func: () => this.declarationHandle(row),
        label: "再次报单",
        isError: true
      }
    };
    // 订单状态
    // 21：Unpaid
    // 31：Processing 待发货
    // 42：Shipped 待收货
    // 51：Completed
    // 61,62：Closed
    // 报单状态
    // 0未报单 1成功 2失败 3进行中
    let declarationMap = { 0: 4, 1: 0, 2: 7, 3: 5 };
    let onlinePayMap = {}; // 线上支付
    let offlinePayMap = {}; // 线下支付
    // 区分K1还是K2
    if (this.isK1Project) {
      // K1 Project
      const declarationType = declarationMap[declarationStatus];
      let decOp: any = [];
      if (declarationStatus != 1) {
        decOp.push(declarationType);
      }
      if (declarationStatus == 0) {
        decOp.push(3);
      }
      onlinePayMap = {
        21: [1],
        31: [2, ...decOp], // 线上支付，不能有取消订单，仅仅是线下支付
        42: [declarationType], // 已报单状态下不会有报单
        51: [declarationType]
      };
      offlinePayMap = {
        21: [1], // 线下支付，未付款不能有取消订单？
        31: !afterSales ? [2, ...decOp, 6] : [6], // 线下支付，待发货状态暂时不做取消订单，需要等oms做完
        42: [declarationType],
        51: [declarationType]
      };
    } else {
      // GiTi Project
      onlinePayMap = {
        21: [1],
        31: [6],
        42: afterSales ? [6] : []
      };
      offlinePayMap = onlinePayMap;
    }
    // payMentType: { online: 线上付款, offline: 线下付款, COD: 货到付款 }
    let showPayMap = {};
    showPayMap = payMentType === "online" ? onlinePayMap : offlinePayMap;
    const operatePayList = showPayMap[parseInt(status)];
    // operateMap
    const operateList =
      operatePayList &&
      operatePayList.map(el => operateMap[el]).filter(Boolean);

    if (!this.isOaCooperation && operateList && operateList.length > 0) {
      // 非合作状态，不显示操作按钮
      operateList.forEach(el => {
        if (el.func) {
          el.isHide = true;
        }
      });
    }
    return operateList;
  }

  isOaCooperation: any = "";
  created() {
    this.memberType = localStorage.getItem("memberType");
    this.marketType = localStorage.getItem("marketType");
    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    let { status = "" } = this.$route.query as any;
    this.activeName = status;

    this.$dd
      .register([
        "ORDER_STATUS",
        "ORDER_PAYMENT_TYPE",
        "TRADE_SOURCE",
        "CHANNEL",
        "PAY_STATUS",
        "CANCEL_REASON_TYPE",
        "LOGISTICS_INFO",
        "ORDER_TYPE",
        "ORDER_EXPRESS_STATUS",
        "ORDER_SOURCE",
        "WT_DISTRIBUTION_TYPE",
        "PAYMENT_METHOD",
        "ORDER_TYPE_WT",
        "ORDER_VERIFICATION_STATUS"
      ])
      .query();

    Promise.all([
      this.getWtStatusCount(),
      this.getDeclarationFn(),
      this.getAttrApi(),
      this.getDicFn(),
      this.getDic()
    ]);
    // this.getWtStatusCount();
    // this.getDeclarationFn();
  }

  async getDeclarationFn() {
    let res = await this.findCompressedDeclarationStatus();
    console.log(res, "--findCompressedDeclarationStatus");
    this.declarationList = res;
  }

  moneyFormat(value) {
    return moneyFormat(value);
  }

  // 获取指定状态数量
  async getWtStatusCount() {
    await this.queryWtOrderStatusCount(this.requestDataCreator(false, false));
  }

  async mounted() {
    await this.getData();
  }

  beforeDestroy() {
    this.clearList();
  }
  // 请求参数生成
  requestDataCreator(pageInfoNeed = true, needStatus = true) {
    let { date, patternList, specificationsList, ...otherForm } = this.form;
    let [startTime = null, endTime = null] = date || [];
    const { pageSize, currentPage: pageNum } = this as any;
    const pageInput = {
      pageSize,
      pageNum
    };

    let orderProductWtInput: any = {
      patternList,
      specificationsList
    };

    let input = {
      ...otherForm,
      startTime: startTime || null,
      endTime: endTime || null,
      orderProductWtInput
    };

    if (pageInfoNeed) {
      return {
        input: {
          ...input,
          orderStatus: this.activeName
        },
        pageInput
      };
    } else {
      return {
        input
      };
    }
  }

  async getData(isLoad = true) {
    try {
      if (isLoad) {
        (this as any).loading = true;
      }
      this.getWtStatusCount();
      let { total, list } = await this.queryWtOrderPage(
        this.requestDataCreator()
      );
      list.forEach(_ => {
        _.showRowAllProducts = this.showAllProducts;
      });
      this.orderDataList = list || [];
      (this as any).total = total;
    } catch (err) {
      console.error(err);
      this.clearList();
      (this as any).total = 0;
    } finally {
      (this as any).loading = false;
    }
  }

  clearList() {
    // this.easyMutate({ path: "orderDataList", data: [] });
    this.orderDataList = [];
  }

  @loadingCatch
  async exportFileFn() {
    await this.exportOrder({ domain: this.requestDataCreator()["input"] });

    // const { href } = this.$router.resolve({
    //   name: "Export",
    //   query: {
    //     activeName: "oms.order"
    //   }
    // });
    // window.open(href, "_blank");
  }

  handeCancelFormChange(val) {
    if (val != this.OTHER_CANCEN_REASON) {
      const { $refs } = this;
      let $form: any = $refs.cancelForm;
      $form.clearValidate("cancelRemark");
    }
  }

  handleOperate = debounce(async (data, type, btnIdx) => {
    let hasOperatePermission: any = await this.getOperatePermissionFn();
    if (!hasOperatePermission) {
      return;
    }
    this.onOperate(data, type, btnIdx);
  }, 500);
  // 取消订单 发货
  async onOperate(data, type, btnIdx) {
    this.dialogRowInfo = data;

    // 获取按钮的index
    this.btnIdx = btnIdx;
    const { orderCode } = data;
    await this.getOrderDeliveryDtlIns(orderCode);

    const { $refs } = this;
    let $form, dialog;
    if (type === "cancel") {
      $form = $refs.cancelForm;
      dialog = $refs.dialog;
      $form && $form.resetFields();
      dialog && (dialog.dialogFormVisible = true);
    }
    // 判断是不是发货并且报单，不是shipOrder的话，就是发货并且报单
    this.isShipOrder = type === "shiporder";
    if (this.isShipOrder || type === "shipDeclarationOrder") {
      this.shiporderDialogHandleOK(data);
    }

    // if (this.isShipOrder && this.currentExpressList.length > 0) {
    if (!this.isShipOrder) {
      $form && $form.resetFields();
    }
  }

  // cancelorder 取消
  cancelorderDialogHandleCancel(row) {
    const { $refs } = this;
    let $form: any = $refs.cancelForm;
    $form && $form.resetFields();
  }

  // isShipOrderData 区分是查看物流还是签收
  async getOrderDetailsAJAX(data, isSend = true) {
    let res = await this.getOrderDetail({
      orderCode: data
    });
    const {
      orderProductOutList = [],
      expressList = [],
      payDate = "",
      orderCode = ""
    } = res;

    const { ORDER_EXPRESS_STATUS_MAP, LOGISTICS_INFO_MAP } = this.ddCodes;
    // shipped 的时候是否有物流信息
    this.currentExpressList = expressList;

    if (isSend) {
      let sendExpressList =
        expressList &&
        expressList
          .filter(({ expressStatus }) => {
            return expressStatus == "1";
          })
          .map(v => {
            let { expressCode, companyCode, companyName } = v;
            return { expressCode, companyCode, companyName };
          });
      return { orderProductOutList, sendExpressList };
    }

    // 物流列表匹配商品 orderItemCode
    let newExpressList =
      expressList &&
      expressList.map(v => {
        let {
          companyCode,
          orderExpressCodeProductOutList = [],
          expressStatus = "1"
        } = v;

        let newProductList = orderExpressCodeProductOutList.map((item, i) => {
          let { count } = item;
          return orderProductOutList.map((jtem, j) => {
            let { actualPrice } = jtem;
            if (item.orderItemCode == jtem.orderItemCode) {
              return {
                ...item,
                ...jtem,
                amountString: moneyFormat(actualPrice * count)
              };
            } else {
              return null;
            }
          });
        });
        // packageInfo 需要的数据
        return {
          ...v,
          statusString:
            (expressStatus && ORDER_EXPRESS_STATUS_MAP[expressStatus]) ||
            ORDER_EXPRESS_STATUS_MAP[1],
          companyName: LOGISTICS_INFO_MAP[companyCode] || companyCode || "-",
          children: newProductList.flat(Infinity).filter(v => v != null)
        };
      });

    this.packageInfoData = {
      expressList: newExpressList,
      payDate,
      orderCode
    };
  }
  // 获取物流信息,ship order必须
  async getOrderDeliveryDtlIns(orderCode) {
    let { orderProductOutList, sendExpressList } =
      await this.getOrderDetailsAJAX(orderCode, true);

    this.orderDeliveryDtlIns = orderProductOutList
      .filter(({ status }) => status != "2")
      .map((v, i) => {
        let { count, orderItemCode, status } = v;
        return {
          orderItemCode,
          count
        };
      });

    return {
      orderProductOutList: [],
      sendExpressList: []
    };
  }
  //  Ship order 确认
  async shiporderDialogHandleOK(data) {
    const { orderCode } = data;

    //后端区分是否发货 Ready to ship ---> false || Shipped --> true
    let shippedFlag = true; // 这里固定是已发货
    const { $refs, orderDeliveryDtlIns, isShipOrder, delayQueryData } = this;
    // 发货
    try {
      this.changeRowLoad(true);
      let { result } = await this.dealWithDelivery({
        ...DEFAULT_DELIVERY_PARAMS,
        orderCode,
        shippedFlag,
        orderDeliveryDtlIns
      });
      if (!isShipOrder) {
        // 发货并报单
        const res = await this.querWtDeclaration({ orderCode });
      }
      this.$message.success("成功");
      delayQueryData();
    } catch (error) {
      delayQueryData();
      console.log(error);
    }
  }
  /**
   * 批量发货（并报单）确认
   * type: 1，发货
   * type: 2，发货并报单
   * type: 3，报单
   */
  handleBatchShipOrders = debounce(async type => {
    let hasOperatePermission: any = await this.getOperatePermissionFn();
    if (!hasOperatePermission) {
      return;
    }
    this.onBatchShipOrders(type);
  }, 500);
  async onBatchShipOrders(type = 1) {
    type = Number(type);
    try {
      const {
        selectedOrderDatas,
        dealDeliveryBatch,
        bulkedeliveryBatch,
        $confirm
      } = this;
      if (selectedOrderDatas && selectedOrderDatas.length === 0) {
        this.$message.warning("请选择发货订单！");
        return;
      }
      const hasShipDatas = selectedOrderDatas.every(
        ({ orderStatus }) => Number(orderStatus) == 31
      );
      if (!hasShipDatas) {
        this.$message.warning("所选订单含不可发货或发货并报单！");
        return;
      }
      const msgMap = {
        1: "确认批量发货？",
        2: "确认批量发货并报单？",
        3: "确认批量报单？"
      };
      await $confirm(msgMap[type], {
        type: "warning"
      });

      this.batchLoading = true;
      const successMsg = () => {
        this.$message.success("操作成功");
      };
      const fnMap = {
        1: async () => {
          const res = await dealDeliveryBatch();
          if (res) {
            successMsg();
          }
        },
        2: async () => {
          // TODO：如果所有的都已经保单，则不需要再调接口
          const response = await dealDeliveryBatch();
          const res = await bulkedeliveryBatch();
          if (res && response) {
            successMsg();
          }
        },
        3: async () => {
          const res = await bulkedeliveryBatch();
          if (res) {
            successMsg();
          }
        }
      };
      fnMap[type]();
      this.delayQuerPageData();
    } catch (error) {
      this.batchLoading = false;
      console.log(error);
    }
  }
  /**
   * 批量发货
   */
  async dealDeliveryBatch() {
    try {
      const SHIPPED_FLAG = true; // 固定值
      const { selectedOrderDatas, dealWithDeliveryBatch, getFailedData } = this;
      const selectInputDatas =
        selectedOrderDatas &&
        selectedOrderDatas.map(({ orderCode, orderProductOutList }) => ({
          ...DEFAULT_DELIVERY_PARAMS,
          orderCode,
          shippedFlag: SHIPPED_FLAG,
          orderDeliveryDtlIns:
            orderProductOutList &&
            orderProductOutList.map(({ orderItemCode, count }) => ({
              orderItemCode,
              count
            }))
        }));
      let res = await dealWithDeliveryBatch({
        input: selectInputDatas
      });
      const failedData = getFailedData(res);
      console.log(res, failedData, "res - delivery");
      if (failedData && failedData.length > 0) {
        this.$message({
          type: "warning",
          message: `订单号：${String(failedData)}发货失败`,
          duration: 3000
        });
        return false;
      }
      return res;
    } catch (error) {
      console.log(error);
    }
  }
  /**
   * 批量报单
   */
  async bulkedeliveryBatch() {
    try {
      const { selectedOrderDatas, bulkdelivery, getFailedData } = this;
      const selectedCodes =
        selectedOrderDatas &&
        selectedOrderDatas.map(({ orderCode = "" }) => orderCode);
      // .filter(({ declarationStatus }) => !!declarationStatus); // 已经报单的就略过
      const res = await bulkdelivery({
        orderList: selectedCodes
      });

      const failedData = getFailedData(res);
      if (failedData && failedData.length > 0) {
        this.$message({
          type: "warning",
          message: `订单号：${String(failedData)}报单失败`,
          duration: 3000
        });
        return false;
      }
      return res;
    } catch (error) {
      console.log(error);
    }
  }
  async dialogHandleOK(data) {
    let cancelMsg: any = "订单已取消！";
    const { orderCode } = data;
    const { $refs } = this;
    let $form: any = $refs.cancelForm;
    let dialog: any = $refs.dialog;

    $form.validate(async valid => {
      if (valid) {
        await this.cancelOrder({
          orderCode,
          ...this.cancelForm
        });
        this.$message.success(cancelMsg);
        this.delayQueryData();
        dialog.dialogFormVisible = false;
        $form.resetFields();
      }
    });
  }
  // 报单操作
  async declarationHandle(data) {
    let hasOperatePermission: any = await this.getOperatePermissionFn();
    if (!hasOperatePermission) {
      return;
    }
    this.$confirm("确认报单？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        const { orderCode } = data;
        await this.querWtDeclaration({ orderCode });
        await this.getCartCount({
          request: {
            marketType: localStorage.getItem("marketType"),
            memberType: localStorage.getItem("memberType")
          }
        });
        this.$message({
          type: "success",
          message: "提交成功"
        });
        this.getData();
      })
      .catch(err => {
        console.log(err);
      });
  }

  rowFooterVisibleCondition(row) {
    let { sellerRemark = "", buyerRemark = "" } = row || {};

    return !!(sellerRemark || buyerRemark);
  }
  getContainer() {
    return document.querySelector(".gt-layout__content");
  }
  getCurrentActivityinfoOutList(item) {
    // activityCode是当前用户下的活动表，outList是所有的活动
    const { activityCode, activityinfoOutList } = item;
    const activityCodeList = activityCode && activityCode.split(",");
    return activityinfoOutList.filter(({ activityCode }) => {
      return activityCodeList.includes(activityCode);
    });
  }
  async delayQueryData() {
    this.changeRowLoad(true);
    setTimeout(async () => {
      await this.getData(false);
      this.$nextTick(() => {
        this.changeRowLoad(false);
      });
    }, 2000);
  }
  async delayQuerPageData() {
    this.batchLoading = true;
    setTimeout(async () => {
      await this.getData(false);
      this.$nextTick(() => {
        this.batchLoading = false;
      });
    }, 2000);
  }
  changeRowLoad(status) {
    this.dialogRowInfo["editLoading"] = status;
  }
  handleSelectChange(selections) {
    this.selectedOrderDatas = selections;
  }
  getFailedData(res) {
    return (
      res &&
      res.data &&
      res.data.api
        .map(({ orderCode, success }) => (!success ? orderCode : null))
        .filter(Boolean)
    );
  }
  async handleRouteChange(row, btnIdx) {
    let hasOperatePermission: any = await this.getOperatePermissionFn();
    if (!hasOperatePermission) {
      return;
    }
    const { orderCode, payMentType } = row;
    if (!orderCode) return;
    try {
      // 获取按钮的index
      this.btnIdx = btnIdx;
      let msg = "确认要取消订单吗？";
      if (!this.isK1Project) {
        msg =
          payMentType !== "online"
            ? msg
            : "确认要取消订单吗？订单取消后退款将原路返回至K2钱包。";
      }
      await this.$confirm(msg, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      const {
        data: {
          api: { success = false }
        }
      } = await this.wtCreateReturn({
        orderCode
      });
      if (success) {
        row["editLoading"] = true;
        setTimeout(async () => {
          await this.getData(false);
          this.$nextTick(() => {
            row["editLoading"] = false;
          });
        }, 2000);
        this.$message.success("订单取消成功");
      } else {
        this.$message.success("订单取消失败，请重试");
      }
    } catch (error) {
      console.log(error);
    }
  }
  /**
   *  根据支付状态判断
      //未支付
      usedPointAmount
      //已支付  状态81
      orderDeductioninfoOutList.deductionAmount
   */
  fBonusMoney(row) {
    try {
      const { usedPointAmount = 0, status, deductionAmount = null } = row;
      const { moneyFormat: getMoneyFormat } = this;
      let bonusDiscount = 0;
      if (status === "21") {
        bonusDiscount = usedPointAmount;
      } else {
        bonusDiscount = deductionAmount;
      }
      return getMoneyFormat(bonusDiscount);
    } catch (error) {
      console.log(error);
      return 0;
    }
  }
  async getOperatePermissionFn() {
    const memberType = localStorage.getItem("memberType");
    const memberCode = localStorage.getItem("memberCode");
    const marketType = localStorage.getItem("marketType");
    let statusInfo: any = await this.getMemberStatus({
      request: {
        memberType,
        memberCode,
        marketType
      }
    });
    let status: any = statusInfo.oaStatus || statusInfo.status;
    if (status !== "11") {
      let error: any = "当前登录账号为非合作状态，暂无操作权限";
      this.$message.error(error);
      return false;
    }
    return true;
  }

  async getAttrApi() {
    const list = await this.getPCRAttr({
      codeList: ["_pattern", "_specification"], // _hubDiameter 尺寸
      orgCode: "default"
    });
    if (list) {
      this.patternDataOptions = (list[0] && list[0].dataList) || [];
      this.specificationDataOptions = (list[1] && list[1].dataList) || [];
    }
  }

  resetSearchFn() {
    this.showAllProducts = false;
    (this as any).onResetBtnClick();
  }
  SearchFn() {
    this.showAllProducts = true;
    (this as any).onSearchBtnClick();
  }

  paymentTypeList: any = [];
  paymentMethodList: any = [];
  paymentTypeMap: any = {};
  async getDicFn() {
    let res = await this.getDict({
      dictCodes: ["ORDER_PAYMENT_TYPE", "ORDER_PAYMENT"]
    });
    this.paymentTypeList = this.wtDicCodes["ORDER_PAYMENT_TYPE"] || [];
    this.paymentMethodList = this.wtDicCodes["ORDER_PAYMENT"] || [];
    this.paymentTypeMap = {};

    this.paymentTypeList.forEach(_ => {
      this.paymentTypeMap[_.dictValue] = _.dictDesc;
    });
    // this.statusTabs = result;
  }

  async getDic() {
    let res = await this.getDataValue({
      dataCode: "CREDIT_SWITCH"
    });
    if (
      res.dataValue === "1" &&
      this.memberType === "11" &&
      this.marketType === "PCR"
    ) {
      this.showFinanceInfo = true;
    }
    console.log(res, "-----CREDIT_SWITCH");
  }
}
